module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "mint-badge",
    class: [_vm.type ? 'mt-color-white mt-bg-' + _vm.type : _vm.type, 'is-size-' + _vm.size],
    style: ([{
      'background-color': _vm.color,
      'color': _vm.fontColor,
      'font-size': _vm.fontSize,
      'padding': _vm.padding,
      'border-radius': _vm.radius,
      'border-color': _vm.bColor
    }])
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a7ce266","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/badge/src/badge.vue
// module id = 370
// module chunks = 0